<template>
  <!-- 劳务人员工地统计 -->
  <div class="laborers-site">
    <div class="title">
      <div class="left">劳务人员工地统计</div>
      <div class="right">
        TOP5
      </div>
    </div>
    <simple-rank :rank-list="workRankList" font-color="#333" :rank-color-list="colorList"/>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import SimpleRank from "@/components/h5/board/SimpleRank.vue";
import commonApi from "@/api/commonApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EmployeeCollection",
  components: {
    SimpleRank
  },
  data() {
    return {
      workRankList: [
        // {buildingName: "绿城.桃源小镇一期", count: 103},
        // {buildingName: "江南一号", count: 88},
        // {buildingName: "绿城.明月江南", count: 55},
        // {buildingName: "绿城.锦绣风华", count: 50},
        // {buildingName: "绿城.春江花月", count: 22},
      ],
      colorList : ["#38d7ff","#38ff6d","#4599ff","#9e66ff","#f94aff"],
    };
  },
  created() {
    // 从缓存中获取菜单
    commonApi.contractWorkerSiteCount({limit: 5}).then(res => {
      let arr = [];
      if (res && res.length) {
        for (let i = 0; i < res.length; i++) {
          arr.push({buildingName: res[i].statisticName, count: res[i].statisticCount});
        }
        this.workRankList = arr;
      }
    })
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../components/h5/board/common";

</style>